module.exports = __webpack_public_path__ + "media/images/icon/deadline-64c139020a4bafb01d96c0a114773756.svg";